<template>
  <div class="grid pb-0">
    <div class="grid-title">
      <h4>{{ $t("_ROLES.BOOKING_ENGINE_CONFIG") }}</h4>
    </div>
    <v-progress-linear color="warning" indeterminate rounded height="3" v-if="isLoading"></v-progress-linear>
    <div class="grid-body border-top-unset">
      <v-row align="center" class="pb-3 pr-3 pl-3">
        <v-col>
          <p class="my-3 fs-12 text-uppercase">{{ $t('DYNAMIC_RATE_METHOD') }}</p>
          <v-radio-group row v-model="eventType" class="mt-0">
            <v-radio v-for="item in optionSchedule" :key="item.key" :label="item.label" :value="item.key"
              disabled></v-radio>
          </v-radio-group>
        </v-col>
      </v-row>
      <div class="pb-3 pr-3 pl-3">
        <p class="mb-1">{{ $t('DESCRIPTION') }}</p>
        <div>
          {{ $t('TITLE_DESCRIPTION_DYNAMIC_CHANGE') }}
          <ul>
            <li>- {{ $t('CHANGE_TYPE_1') }}</li>
            <li>- {{ $t('CHANGE_TYPE_2') }}</li>
            <li>- {{ $t('CHANGE_TYPE_3') }}</li>
            <li>- {{ $t('CHANGE_TYPE_4') }}</li>
            <li>- {{ $t('CHANGE_TYPE_5') }}</li>
            <li>- {{ $t('CHANGE_TYPE_6') }}</li>
          </ul>
        </div>
        <p class="mt-3 mb-1">{{ $t('STATUS') }}</p>
        <v-switch class="mt-0" v-model="active" :label="active ? $t('ACTIVE') : $t('DEACTIVE')"
          @change="$event => action($event)"></v-switch>
      </div>
    </div>
    <confirm-dialog @deleteItem="actionDynamic" :maxWidth="325" :persistent="true" ref="actionDialogComponent">
      <span slot="title">{{ $t("CONFIRM_DEACTIVE_DYNAMIC_RATE") }}</span>
    </confirm-dialog>
  </div>
</template>
  
<style lang="scss" scoped>
.table-syncPMS {
  padding: 0;

  .v-card__text {
    padding: 0;
  }
}

#service-list {
  td {
    vertical-align: middle;
  }

  button.sortHandle {
    outline: none;
  }

  .service-status {
    justify-content: center;
    margin-top: 5px;
  }
}
</style>
  
<script>
import { dynamicService } from "@/_services/SaleRoom/smart-pricing.service.js";
import ConfirmDialog from "@/components/Utils/ConfirmDialog.vue";
import { _alert } from "@/_helpers/function.js";
export default {
  components: {
    "confirm-dialog": ConfirmDialog,
  },
  data() {
    return {
      isLoading: true,
      sysLang: this.$i18n.locale || "vi",
      optionSchedule: [
        {
          label: this.$t("EVENT"),
          key: 0,
        },
        {
          label: this.$t("CALENDAR"),
          key: 1,
        },
      ],
      eventType: 0,
      active: false,
      id: null,
    };
  },
  created() {
    this.detailSchedule();
  },
  methods: {
    detailSchedule() {
      dynamicService
        .detailSchedule()
        .then((res) => {
          if (res.responseCode === 0) {
            this.eventType = res.data.eventType;
            this.active = res.data.active === 1;
            this.id = res.data.id
          }
        })
        .finally(() => (this.isLoading = false));
    },
    action(value) {
      if (!value) {
        this.$refs.actionDialogComponent.open(null);
      } else {
        this.actionDynamic()
      }
    },
    actionDynamic() {
      this.isLoading = true;
      const body = {
        id: this.id,
        active: this.active ? 1 : 0,
        eventType: this.eventType,
        schedulingStart: null,
        schedulingStop: null,
        schedulingType: 0,
        schedulingStep: 0,
        schedulingValue: 0,
        schedulingTime: null,
        schedulingNext: null,
        hotel: null
      }
      dynamicService
        .updateScheduleDynamic(body)
        .then((res) => {
          _alert(res, this.$t(res.data), false);
          this.detailSchedule()
        })
        .finally(() => (this.isLoading = false));
    }
  },
};
</script>
  